import { handleError } from 'utils/js/error_helpers'

const adCheck = ads => {
    for (let i = 0; i < ads.length; i++) {
        if (window.adUtility.elementInView(ads[i])) {
            let ad = document.getElementById(ads[i])
            window.adUtility.refresh(ad)
        }
    }
}

const adsRefresh = () => next => action => {
    switch (action.type) {
        case 'BAT_ADS_EVENT':
            if (typeof window.adUtility !== 'undefined') {
                try {
                    var adIds = ['bigbox_ad_01', 'leaderboard_01']
                    adCheck(adIds)
                } catch (e) {
                    handleError(e)
                }
            }
            break

        case 'INIT_HEADER_LEADERBOARD_AD':
            if (typeof window.adUtility !== 'undefined') {
                try {
                    if (window.snBreakpointWatcher.breakPoint() >= 768) {
                        window.adUtility.insertAd('leaderboard', {
                            type: window.adUtility._AD_LEADERBOARD_MASTER,
                            adPath: action.adUnitPath,
                            targeting: action.adTargets,
                        })
                    }
                } catch (e) {
                    handleError(e)
                }
            }
            break

        default:
            return next(action)
    }
}

export default adsRefresh
